import { cn } from '../lib/cn';
import { Icon } from './icon';

export interface SwipeBackIndicatorProps {
  /** How far the indicator has come in from the left edge, in pixels. 0 hides it. */
  distance: number;
  /** From this distance on, letting go goes back. */
  threshold: number;
}

/**
 * Indicator of the swipe back from the left edge (docs/ui/responsive.md, Gesten), the sideways
 * sibling of `PullIndicator`: a round arrow follows the finger and takes the primary color once
 * letting go goes back. Purely visual; the back link in the top bar is the way without gesture.
 */
export function SwipeBackIndicator({ distance, threshold }: SwipeBackIndicatorProps) {
  const progress = Math.min(distance / threshold, 1);
  const armed = progress >= 1;
  return (
    <div aria-hidden className="pointer-events-none fixed inset-y-0 left-0 z-30 flex items-center">
      <span
        className={cn(
          'flex size-10 items-center justify-center rounded-full border border-line bg-surface shadow-overlay',
          armed ? 'text-brand' : 'text-fg-muted',
          distance === 0 && 'transition-[translate,opacity] transition-base',
        )}
        style={{
          translate: `calc(${distance}px - 100%) 0`,
          opacity: distance > 0 ? Math.max(progress, 0.3) : 0,
        }}
      >
        <Icon name="chevron-left" className="size-5" />
      </span>
    </div>
  );
}
